<template>
  <div id="app" v-loading.fullscreen.lock="loadingApp"
    element-loading-text="拼命加载中..." 
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)">
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data: function () {
    return {
      // profile: 'dev',
      profile: 'prod',
      authenticated: true,
      userName: '',
      deptName: '',

      modeSelectList: [],

      loadingApp: false,
      showMe: true,

      imgUrl: require(this.global.commonParam.bannerLogo + '.png'),

      collapsed: false,
      leftWidth: '240px',
      rightWidth: 'el-main',
      shrinkstyle: 'menu-toggle',

      shrink: false,
      showshrink: true,

      // dialogFormVisible: false,

      isShow: true,
      functionTitle: '首页',
      // 多标签使用的路由
      route: [],

      // 功能菜单（根据权限加载）
      rightCtrlList: [],

      activeTab: 'default',
      tabList: [{ title: '首页', name: 'default', itemId: '0' }],
      tabCount: 1,
      maxTabCount: 5
    }
  },
  watch: {
    '$route': 'processAccessOut'
  },
  mounted: function () {
    // 记录本地存储
    var self = this
    if (this.$route.query.openId) {
      localStorage.openId = this.$route.query.openId
    }
    if (this.$route.query.openid) {
      localStorage.openId = this.$route.query.openid
    }
    if (this.$route.query.deptId) {
      localStorage.deptId = this.$route.query.deptId
    }
    if (this.$route.query.type) {
      localStorage.type = this.$route.query.type
    }

    // 接收陕师大的参数
    if (this.$route.query.stu_name) {
      localStorage.userName = this.$route.query.stu_name
    }
    if (this.$route.query.stu_no) {
      localStorage.keyInfo = this.$route.query.stu_no
    }
    if (this.$route.query.fdzid) {
      localStorage.fdzid = this.$route.query.fdzid || ''
      localStorage.studentType = '01'
      localStorage.majorcode = ''
    }
    if (this.$route.query.majorcode) {
      localStorage.majorcode = this.$route.query.majorcode || ''
      localStorage.studentType = '02'
      localStorage.fdzid = ''
    }

    this.global.curUser.userName = localStorage.userName || ''
    this.global.curUser.keyInfo = localStorage.keyInfo || ''
    this.global.curUser.openId = localStorage.openId
    this.global.deptId = parseInt(localStorage.deptId)
    this.global.type = localStorage.type

    this.global.loginType = this.$route.query.loginType || ''
    console.log('App里：', this.global.type)
    if (process.env.NODE_ENV === 'production') {
      self.axios.all([self.getMode(), self.getUISet()]
      ).then(self.axios.spread(function (mode, uiSet) {
        if (mode.data.result.success === true) {
          self.modeSelectList = mode.data.modeList
          self.global.modeList = mode.data.modeList
          self.global.staticResourceAddr = self.modeSelector('Access_URL_Payment').filter(mode => mode.modeId === '02' && mode.field1 === self.global.appTitle)[0].modeValue
          self.global.wechatAuthUrl = self.modeSelector('Access_URL_Payment').filter(mode => mode.modeId === '03' && mode.field1 === self.global.appTitle)[0].modeValue
          self.global.payUrl = self.modeSelector('Access_URL_Payment').filter(mode => mode.modeId === '08' && mode.field1 === self.global.appTitle)[0].modeValue
          self.global.staticUploadAddr = self.modeSelector('Access_URL_Payment').filter(mode => mode.modeId === '07' && mode.field1 === self.global.appTitle)[0].modeValue
        }
        if (uiSet.data.result.success === true) {
          self.global.uiSetItemList = uiSet.data.uiSetItemList
          self.global.uiSetList = uiSet.data.uiSetList
        }
        self.toRoute()
      }))
    } else {
      this.toRoute()
      console.log('xxxxxxxxxxxxxxxxx', this.Ginkgo.format(24543.98999, 'number'))
      // this.$router.push('/PayFeeCourt')
      // this.route = [{ path: '/PayFeeCourt', component: require('./components/Pay/PayFeeCourt.vue'), meta: { title: '缴费' } }]
      // this.$router.addRoutes(this.route)
    }
  },
  methods: {
    // 初始化数据字典
    getMode: function () {
      var self = this
      return self.axios.get('/public/getModeByTypeList', { params: { typeList: self.global.typeIdList } })
    },
    // 加载界面配置
    getUISet: function (uiSetIdList) {
      var self = this
      return self.axios.get('/public/getUISetItemByIDList', { params: { setIdList: self.global.uiSetIdList } })
    },
    // 根据当前机构Id和活动标签获取需要加载的页面
    getPageByDeptId: function (type) {
      return this.global.pageMap.filter(element => element.type === type)
    },
    // 标签点击事件
    toRoute: function () {
      let pageItem = this.getPageByDeptId(this.global.type)
      if (pageItem.length > 0) {
        this.$router.push('/' + pageItem[0].pageName)
        this.route = [{ path: '/' + pageItem[0].pageName, component: require('./components/' + pageItem[0].pageUrl + '.vue'), meta: { title: pageItem[0].title } }]
        this.$router.addRoutes(this.route)
        document.title = pageItem[0].title
      }
    },
    // 数据字典筛选器
    modeSelector: function (typeId) {
      return this.modeSelectList.filter(function (element) {
        return element.typeId === typeId
      })
    },
    // 处理外部访问
    processAccessOut: function () {
      if (this.$route.path === '/') {
        this.global.curUser.openId = localStorage.openId
        this.global.deptId = parseInt(localStorage.deptId)
        this.global.type = localStorage.type
        this.toRoute()
      }
    }
  }
}
</script>

<style>
  .el-main {
    /* width: 60%; */
    /* margin-left: 240px; */
    text-align: left;
    margin-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?1ccab1f2